// import React, { useState, useEffect } from "react";
// import DataTable from "react-data-table-component";
// import FilterModal from "../Filter Modal/FilterModal";

// export default function DataTable_Component({ apidata, columns, searchBy }) {
//   const [dataFilter, setDataFilter] = useState("");
//   const [statusFilter, setStatusFilter] = useState("");
//   const [filteredData, setFilteredData] = useState([]);
//   const [showFilterModal, setShowFilterModal] = useState(false);

//   useEffect(() => {
//     let filtered = apidata;
//     // Filter by search term
//     if (dataFilter) {
//       filtered = filtered.filter((item) => {
//         // Flexible search logic for different fields
//         if (searchBy === "name") {
//           return (
//             item.agent_name &&
//             item.agent_name.toLowerCase().startsWith(dataFilter.toLowerCase())
//           );
//         }
//         // Add more conditions as needed for other fields
//         return false;
//       });
//     }

//     setFilteredData(filtered);
//   }, [dataFilter, statusFilter, apidata, searchBy]);

//   const applyFilters = () => {
//     setShowFilterModal(false);
//   };

//   const removeFilters = () => {
//     setShowFilterModal(false);
//   };

//   return (
//     <div className="table-responsive">
//       <div className="row justify-content-between mb-2">
//         <div className="col-md-3 mb-2">
//           <input
//             type="text"
//             placeholder={`Search by ${searchBy}`}
//             className="form-control"
//             value={dataFilter}
//             onChange={(e) => setDataFilter(e.target.value)}
//           />
//         </div>
//         <div className="col-md-9 mb-2">
//           <button
//             className="btn btn-primary"
//             onClick={() => setShowFilterModal(true)}
//           >
//             Filter
//           </button>
//         </div>
//       </div>
//       {filteredData.length > 0 ? (
//         <DataTable
//           columns={columns}
//           data={filteredData}
//           pagination
//           fixedHeader
//           highlightOnHover
//           responsive
//           paginationPerPage={5}
//           paginationRowsPerPageOptions={[5, 10, 15, 20]}
//         />
//       ) : (
//         <div className="row justify-content-start">
//           <div className="col-12">
//             <p>No results found.</p>
//           </div>
//         </div>
//       )}
//       <FilterModal
//         show={showFilterModal}
//         onHide={() => setShowFilterModal(false)}
//         statusFilter={statusFilter}
//         setStatusFilter={setStatusFilter}
//         applyFilters={applyFilters}
//         removeFilters={removeFilters}
//         apidata={apidata}
//       />
//     </div>
//   );
// }

import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import FilterModal from "../Filter Modal/FilterModal";

export default function DataTable_Component({ apidata, columns, searchBy }) {
  const [dataFilter, setDataFilter] = useState("");

  const [categoryFilter, setCategoryFilter] = useState("");
  const [interestedFilter, setInterestedFilter] = useState("");
  const [ratingFilter, setRatingFilter] = useState("");

  const [filteredData, setFilteredData] = useState([]);
  const [showFilterModal, setShowFilterModal] = useState(false);

  useEffect(() => {
    let filtered = apidata;

    // SEARCH FILTER
    // if (dataFilter) {
    //   filtered = filtered.filter((item) =>
    //     item.agent_name?.toLowerCase().includes(dataFilter.toLowerCase())
    //   );
    // }
    if (dataFilter) {
      const search = dataFilter.toLowerCase();

      filtered = filtered.filter(
        (item) =>
          item.agent_name?.toLowerCase().includes(search) ||
          item.phone_number?.toString().includes(search)
      );
    }

    // BUSINESS CATEGORY FILTER (object)
    if (categoryFilter) {
      filtered = filtered.filter(
        (item) =>
          item.business_category?.name?.toLowerCase() ===
          categoryFilter.toLowerCase()
      );
    }

    // INTERESTED FILTER (true/false)
    if (interestedFilter) {
      const isInterested = interestedFilter === "Yes" ? true : false;
      filtered = filtered.filter((item) => item.interested === isInterested);
    }

    // RATING FILTER (number)
    if (ratingFilter) {
      filtered = filtered.filter(
        (item) => item.rating?.toString() === ratingFilter.toString()
      );
    }

    setFilteredData(filtered);
  }, [dataFilter, categoryFilter, interestedFilter, ratingFilter, apidata]);

  const applyFilters = () => {
    setShowFilterModal(false);
  };

  const removeFilters = () => {
    setCategoryFilter("");
    setInterestedFilter("");
    setRatingFilter("");
    setShowFilterModal(false);
  };

  return (
    <div className="table-responsive">
      <div className="row justify-content-between mb-2">
        <div className="col-md-3 mb-2">
          <input
            type="text"
            placeholder={`Search by ${searchBy} / Phonenumber`}
            className="form-control"
            value={dataFilter}
            onChange={(e) => setDataFilter(e.target.value)}
          />
        </div>
        <div className="col-md-9 mb-2">
          <button
            className="btn btn-primary"
            onClick={() => setShowFilterModal(true)}
          >
            Filter
          </button>
        </div>
      </div>

      <DataTable
        columns={columns}
        data={filteredData}
        pagination
        fixedHeader
        highlightOnHover
        responsive
        paginationPerPage={5}
        paginationRowsPerPageOptions={[5, 10, 15, 20]}
      />

      {/* FILTER MODAL */}
      <FilterModal
        show={showFilterModal}
        onHide={() => setShowFilterModal(false)}
        categoryFilter={categoryFilter}
        setCategoryFilter={setCategoryFilter}
        interestedFilter={interestedFilter}
        setInterestedFilter={setInterestedFilter}
        ratingFilter={ratingFilter}
        setRatingFilter={setRatingFilter}
        applyFilters={applyFilters}
        removeFilters={removeFilters}
        apidata={apidata}
      />
    </div>
  );
}
